import ProgressStatusJourney from 'dashboard/templates/views/Patient/Progress/ProgressStatusJourney';

export default {
  path: 'journey',
  name: 'PatientRecordProgressStatusJourney',
  component: ProgressStatusJourney,
  meta: {
    // title: 'Patient Record - Progress - Status - Journey',
    // title: t => `${t('patient.patientRecord')} - ${t('journeyProgress.progress')} - ${t('journeyBehaviourChangeGoals.status')} - ${t('buttons.journey', 'app_mobile')}`,
    // title: 'Journey - Status',
    title: t => `${t('buttons.journey', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
